import { create } from "zustand";

interface SeachModal {
    isSearchModalOpen: boolean;
    openSearchModal: () => void;
    closeSearchModal: () => void;
    toggleSearchModal: () => void;
}

export const useSearchModal = create<SeachModal>()((set) => ({
    isSearchModalOpen: false,
    openSearchModal: () => set({ isSearchModalOpen: true }),
    closeSearchModal: () => set({ isSearchModalOpen: false }),
    toggleSearchModal: () =>
        set((state) => ({ isSearchModalOpen: !state.isSearchModalOpen })),
}));
